import { render, staticRenderFns } from "./OrderDeliveryForm.vue?vue&type=template&id=68350044&"
import script from "./OrderDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports